import type { ReactNode } from 'react';

/**
 * App-wide handlers for ICU rich-text tags, passed to `IntlProvider` as
 * `defaultRichTextElements` so tagged messages like `<em>{email}</em>` render
 * instead of leaking literal markup. Per-message `values` still override.
 * Module scope keeps the provider's `intl` object referentially stable.
 */
export const DEFAULT_RICH_TEXT_ELEMENTS = {
  // The static key suppresses React's key warning: rich-text chunks render as an array.
  em: (chunks: ReactNode) => (
    <span key="em" className="font-semibold">
      {chunks}
    </span>
  ),
};
